import Header from '../components/Header';
import * as locCon from '../LocalConstants';
import * as libCon from '../community-hats-js-library/Constants';

import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import SensorInboxEmail from '../components/SensorInboxEmail';
import ActivationCodeLoader from '../components/ActivationCodeLoader';
import { SimpleCopyFieldFromATO } from '../elements/SimpleStoreCopyField';

export function ToolGoveeActivationCodes() {
  const i18n = RefContextLanguage();

  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={true} />

        <CustomText type={locCon.SECTION_TITLE_TEXT} style={{ marginBottom: '1.5vh' }}>
          {i18n.t('goveeCredentials')}
        </CustomText>

        <div>
          <SimpleCopyFieldFromATO
            atoId={locCon.AT_OBJECT_EMAIL_ACCOUNT}
            fieldId={libCon.ATF_EMAIL}
            title={i18n.t('goveeEmail')}
            processFunction={(val) => (val === null || val === undefined ? null : val)}
          />
          <SimpleCopyFieldFromATO
            atoId={locCon.AT_OBJECT_EMAIL_ACCOUNT}
            fieldId={libCon.ATF_GOVEE_PASSWORD}
            title={i18n.t('goveePassword')}
          />
        </div>

        <div className="horizontalLine" />

        <CustomText type={locCon.SECTION_TITLE_TEXT} style={{ marginBottom: '1.5vh' }}>
          {i18n.t('goveeActivationCodes')}
        </CustomText>
        <SensorInboxEmail />
        <ActivationCodeLoader />
      </div>
    </div>
  );
}

export default ToolGoveeActivationCodes;
